import React, { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { ChevronDown, ExternalLink } from "lucide-react";
import { services } from "./servicesData";

function ServicesDropdown() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    function onClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div
      className="rx-dropdown-wrap"
      ref={wrapRef}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={`rx-dropdown-trigger ${open ? "active" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        Services
        <ChevronDown size={14} className={`rx-chevron ${open ? "flip" : ""}`} />
      </button>
      {open && (
        <div className="rx-dropdown-panel">
          {services.map((s) => (
            <NavLink
              key={s.slug}
              to={`/services#${s.slug}`}
              className="rx-dropdown-item"
              onClick={() => setOpen(false)}
            >
              {s.title}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Header() {
  return (
    <>
      <header className="rx-header">
        <div className="rx-header-inner">
          <img src="./img/logo.png" alt="Reliable Express" className="branding" />
          <nav className="rx-nav">
            <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")}>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
              About Us
            </NavLink>
            <ServicesDropdown />
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
              Contact Us
            </NavLink>
          </nav>
          <button className="rx-portal-btn">
            <ExternalLink size={14} /> Track Now
          </button>
        </div>
      </header>
    </>
  );
}